module.exports = __webpack_public_path__ + "img/MCAST_logo.f8bdd15e.png";